module.exports = __webpack_public_path__ + "img/symbol_12.61f5321e.png";